/** @file Type definitions for select component configurations */

/**
 * Available size variants for select components
 *
 * - NativeSelect supports: sm, md, lg
 * - Dropdown supports: sm, md, lg, xl
 */
export type HxSelectSize = 'sm' | 'md' | 'lg' | 'xl';

/** Position options for dropdown placement Based on CDK Overlay positioning strategies */
export type HxSelectPosition =
  | 'top-start'
  | 'top'
  | 'top-end'
  | 'right-start'
  | 'right'
  | 'right-end'
  | 'bottom-start'
  | 'bottom'
  | 'bottom-end'
  | 'left-start'
  | 'left'
  | 'left-end'
  | 'auto';

/** State of the select component */
export type HxSelectState = {
  /** Whether the select is in error state */
  error: boolean;

  /** Whether the select is disabled */
  disabled: boolean;

  /** Whether the select is read-only */
  readonly: boolean;

  /** Whether the select is focused */
  focused: boolean;

  /** Whether the dropdown is open (Dropdown only) */
  open?: boolean;
};

/** Validation result for select component */
export type HxSelectValidation = {
  /** Whether the current value is valid */
  valid: boolean;

  /** Error message if validation failed */
  errorMessage?: string;
};

/** Type for select component search filter function */
export type HxSelectFilterFn<T> = (option: T, searchQuery: string) => boolean;

/** Default filter function for options based on label */
export function defaultSelectFilter<T extends { label: string }>(option: T, searchQuery: string): boolean {
  if (!searchQuery || searchQuery.trim() === '') {
    return true;
  }
  return option.label.toLowerCase().includes(searchQuery.toLowerCase());
}
